import { DOCUMENT_SCORECARD, FILTERS } from '@Constants/types';
import { STORAGE_TYPE, getFromStorage } from '@Service/storageService';
import { defaultDigiApp } from '@Utils/commonUtils';
import { ScorecardStatus } from '@Constants/status';
import { prepareDigAppsList } from '@Utils/jsonUtils';

export default function scoreCardReducer(
    state = {
        digAppsFilteredArray: [],
        enabled: false,
        malConfigured: false,
        scorecard: null,
        scorecardStatus: null,
        isImporting: { digApps: false, scorecards: false, pullingScorecards: false },
        failedRequestsCount: 0,
        failedMessage: { digApps: '', scorecards: '' },
        scorecardPollingEnabled: false,
        digAppsPendingStatus: []
    },
    action
) {
    switch (action.type) {
        // DigApps
        case DOCUMENT_SCORECARD.FETCH_DIGAPP_REQUEST:
            return { ...state, isImporting: { ...state.isImporting, digApps: true } };
        case DOCUMENT_SCORECARD.FETCH_DIGAPP_SUCCESS:
            return {
                ...state,
                enabled: action.payload.enabled,
                digAppsFilteredArray: action.payload.digAppsFilteredArray,
                malConfigured: action.payload.malconfigured,
                isImporting: { digApps: false, scorecard: false, pullingScorecards: false },
                // scorecardStatusCount: action.payload.digAppCount,
                digAppsPendingStatus: action.payload.digAppsPendingStatus,
                failedRequestsCount: 0,
                failedMessage: { digApps: '', scorecards: '' }
            };
        case DOCUMENT_SCORECARD.FETCH_DIGAPP_FAILURE:
            return {
                ...state,
                enabled: false,
                malConfigured: false,
                digAppsFilteredArray: [],
                digAppsSelectionInput: {},
                isImporting: { digApps: false, scorecard: false, pullingScorecards: false },
                failedRequestsCount: 0,
                failedMessage: { digApps: action.payload }
            };
        // On system change
        case DOCUMENT_SCORECARD.CLEAR_DIGAPPS:
            return {
                ...state,
                digAppsFilteredArray: [],
                enabled: false,
                malconfigured: false,
                scorecard: null,
                isImporting: { digApps: false, scorecard: false, pullingScorecards: false },
                failedRequestsCount: 0,
                failedMessage: { digApps: '', scorecards: '' },
                scorecardStatus: ScorecardStatus.NOT_ANALYZED
            };
        // Scorecards
        case DOCUMENT_SCORECARD.FETCH_SCORECARD_REQUEST:
            return {
                ...state,
                isImporting: { ...state.isImporting, scorecard: true },
                scorecardStatus: ScorecardStatus.PENDING,
                failedMessage: { digApps: '', scorecards: '' }
            };
        case DOCUMENT_SCORECARD.TOGGLE_OFF_PULLING:
            return { ...state, isImporting: { ...state.isImporting, pullingScorecards: false } };
        case DOCUMENT_SCORECARD.FETCH_SCORECARD_PENDING:
            return {
                ...state,
                isImporting: { digApps: false, scorecard: false, pullingScorecards: true },
                failedRequestsCount: state.failedRequestsCount + 1,
                failedMessage: { digApps: '', scorecards: '' },
                scorecardStatus: ScorecardStatus.PENDING
            };
        case DOCUMENT_SCORECARD.FETCH_SCORECARD_SUCCESS:
            return {
                ...state,
                isImporting: { digApps: false, scorecard: false, pullingScorecards: false },
                scorecard: action.payload,
                scorecardStatus: ScorecardStatus.PROCESSED,
                failedMessage: { digApps: '', scorecards: '' },
                scorecardPollingEnabled: false
            };
        case DOCUMENT_SCORECARD.FETCH_SCORECARD_FAILURE:
            return {
                ...state,
                isImporting: { digApps: false, scorecard: false, pullingScorecards: false },
                failedRequestsCount: 0,
                failedMessage: { scorecards: action.payload },
                scorecardStatus: ScorecardStatus.NOT_ANALYZED
            };
        // On digApp change
        case DOCUMENT_SCORECARD.CLEAR_SCORECARD:
            return {
                ...state,
                scorecard: null,
                isImporting: { digApps: false, scorecard: false, pullingScorecards: false },
                failedRequestsCount: 0,
                failedMessage: { digApps: '', scorecards: '' },
                scorecardStatus: ScorecardStatus.NOT_ANALYZED
            };
        // Scorecard polling
        case DOCUMENT_SCORECARD.ENABLE_SCORECARD_POLLING:
            return { ...state, scorecardPollingEnabled: true };
        case DOCUMENT_SCORECARD.DISABLE_SCORECARD_POLLING:
            return { ...state, scorecardPollingEnabled: false };
        // case DOCUMENT_SCORECARD.RULE_STATUS_RETURNED: {
        //     const currentDigAppsPendingStatus = state.digAppsPendingStatus;
        //     const index = currentDigAppsPendingStatus.indexOf(action.payload);
        //     if (index > -1) {
        //         currentDigAppsPendingStatus.splice(index, 1);
        //     }

        //     return { ...state, digAppsPendingStatus: currentDigAppsPendingStatus };
        // }
        case DOCUMENT_SCORECARD.SLE_PROCESS_STARTED:
            return { ...state };
        case DOCUMENT_SCORECARD.FETCH_ANALYZERS_DETAILS:
            return { ...state, digAppsFilteredArray: action.payload, digAppsPendingStatus: [] };
        case DOCUMENT_SCORECARD.UPDATE_SCORECARDS_WITH_CLAUSES_SUCCESS:
            return { ...state, scorecard: action.payload };
        default:
            return state;
    }
}

const filtersInitialState = {
    // FILTERS FLAGS
    AnswersFlagsInput: {
        Yes: { text: 'Yes', selected: false },
        No: { text: 'No', selected: false },
        Other: { text: 'Other', selected: false }
    },
    suggestedClauseInput: {
        Yes: { text: 'Yes', selected: false },
        No: { text: 'No', selected: false }
    },
    extractionFlagsInput: {
        Yes: { text: 'Yes', selected: false },
        No: { text: 'No', selected: false }
    },
    SortFlagsInput: {
        headerRL: { text: 'Risk Level' },
        NoSortingRL: {
            text: 'No sorting',
            selected: false,
            opposite: ['RiskHL', 'RiskLH']
        },
        RiskHL: {
            text: 'Risk (High - Low)',
            selected: true,
            opposite: ['RiskLH', 'NoSortingRL']
        },
        RiskLH: {
            text: 'Risk (Low - High})',
            selected: false,
            opposite: ['RiskHL', 'NoSortingRL'],
            divider: true
        },
        headerTopic: { text: 'Topic' },
        NoSortingTopic: {
            text: 'No sorting',
            selected: true,
            opposite: ['TOPICZA', 'TOPICAZ']
        },
        TOPICAZ: {
            text: 'Topic (A-Z)',
            selected: false,
            opposite: ['TOPICZA', 'NoSortingTopic']
        },
        TOPICZA: { text: 'Topic (Z-A)', selected: false, opposite: ['TOPICAZ', 'NoSortingTopic'] }
    },
    riskFlagsInput: {},
    topicFlagsInput: {},
    subTopicFlagsInput: {},
    activeFilters: {}
};

const isFilterActive = flags => !!Object.values(flags).filter(flag => flag.selected).length;

export function scoreCardFiltersReducer(state = filtersInitialState, action) {
    switch (action.type) {
        // SET FILTERS
        case FILTERS.SET_RISK_LEVELS:
            return { ...state, riskFlagsInput: action.payload };
        case FILTERS.SET_TOPICS:
            return { ...state, topicFlagsInput: action.payload };
        case FILTERS.SET_SUBTOPICS:
            return { ...state, subTopicFlagsInput: action.payload };
        case FILTERS.SET_SORTING:
            return { ...state, SortFlagsInput: action.payload };
        // UPDATE FILTERS
        case FILTERS.FILTER_BY_RISK_LEVELS:
            return {
                ...state,
                riskFlagsInput: action.payload,
                activeFilters: {
                    ...state.activeFilters,
                    filterByRiskLevels: {
                        active: isFilterActive(action.payload),
                        flags: action.payload
                    }
                }
            };
        case FILTERS.FILTER_BY_TOPICS:
            return {
                ...state,
                topicFlagsInput: action.payload,
                activeFilters: {
                    ...state.activeFilters,
                    filterByTopics: {
                        active: isFilterActive(action.payload),
                        flags: action.payload
                    }
                }
            };
        case FILTERS.FILTER_BY_SUBTOPICS:
            return {
                ...state,
                subTopicFlagsInput: action.payload,
                activeFilters: {
                    ...state.activeFilters,
                    filterBySubTopics: {
                        active: isFilterActive(action.payload),
                        flags: action.payload
                    }
                }
            };
        case FILTERS.FILTER_BY_ANSWERS:
            return {
                ...state,
                AnswersFlagsInput: action.payload,
                activeFilters: {
                    ...state.activeFilters,
                    filterByAnswer: {
                        active: isFilterActive(action.payload),
                        flags: action.payload
                    }
                }
            };
        case FILTERS.FILTER_BY_SUGGESTED_CLAUSES:
            return {
                ...state,
                suggestedClauseInput: action.payload,
                activeFilters: {
                    ...state.activeFilters,
                    filterBySuggestedClauses: {
                        active: isFilterActive(action.payload),
                        flags: action.payload
                    }
                }
            };
        case FILTERS.FILTER_BY_EXTRACTIONS:
            return {
                ...state,
                extractionFlagsInput: action.payload,
                activeFilters: {
                    ...state.activeFilters,
                    filterByExtractions: {
                        active: isFilterActive(action.payload),
                        flags: action.payload
                    }
                }
            };
        case FILTERS.UPDATE_SORTING:
            return {
                ...state,
                SortFlagsInput: action.payload,
                activeFilters: {
                    ...state.activeFilters,
                    sortByTopic: { active: isFilterActive(action.payload), flags: action.payload },
                    sortByRiskLevels: {
                        active: isFilterActive(action.payload),
                        flags: action.payload
                    }
                }
            };
        case FILTERS.RESET_FILTERS: {
            const { SortFlagsInput, topicFlagsInput, subTopicFlagsInput, riskFlagsInput } = state;

            return {
                ...state,
                AnswersFlagsInput: {
                    Yes: { text: 'Yes', selected: false },
                    No: { text: 'No', selected: false },
                    Other: { text: 'Other', selected: false }
                },
                suggestedClauseInput: {
                    Yes: { text: 'Yes', selected: false },
                    No: { text: 'No', selected: false }
                },
                extractionFlagsInput: {
                    Yes: { text: 'Yes', selected: false },
                    No: { text: 'No', selected: false }
                },
                SortFlagsInput: SortFlagsInput,
                riskFlagsInput: riskFlagsInput,
                topicFlagsInput: topicFlagsInput,
                subTopicFlagsInput: subTopicFlagsInput,
                activeFilters: {}
            };
        }

        default:
            return state;
    }
}

export function digAppsSelectorReducer(
    state = {
        digAppsSelectionInput: {},
        availableDigAppsCount: 0
    },
    action
) {
    const digAppsWithActiveRules = { ...state.digAppsSelectionInput };
    let digAppName = '';
    // const updatedDigAppsSelectionInput = Object.assign({}, state.digAppsSelectionInput);

    switch (action.type) {
        case DOCUMENT_SCORECARD.UPDATE_DIGAPP:
            return {
                digAppsSelectionInput: action.payload,
                availableDigAppsCount: Object.values(action.payload).length
            };
        case DOCUMENT_SCORECARD.FETCH_ANALYZERS_DETAILS:
            return {
                digAppsSelectionInput: prepareDigAppsList(action.payload),
                availableDigAppsCount: Object.values(action.payload).length
            };
        // case DOCUMENT_SCORECARD.TOGGLE_FAVORITE:
        //     updatedDigAppsSelectionInput[action.payload].favorite = !updatedDigAppsSelectionInput[
        //         action.payload
        //     ].favorite;
        //     return {
        //         ...state,
        //         digAppsSelectionInput: updatedDigAppsSelectionInput
        //     };
        case DOCUMENT_SCORECARD.CLEAR_DIGAPPS:
            return {
                digAppsSelectionInput: {},
                availableDigAppsCount: 0
            };
        case DOCUMENT_SCORECARD.REMOVE_RULELESS_DIGAPPS:
            digAppName = getFromStorage('digAppName', STORAGE_TYPE.PROPERTY_BAG);
            delete digAppsWithActiveRules[action.payload];

            // select digAppName from prop_bag if exists, else select the default digApp
            if (digAppName && Object.keys(digAppsWithActiveRules).includes(digAppName)) {
                digAppsWithActiveRules[digAppName].selected = true;
            } else {
                const selectedDigApp = defaultDigiApp(digAppsWithActiveRules);
                if (digAppsWithActiveRules[selectedDigApp]) {
                    digAppsWithActiveRules[selectedDigApp].selected = true;
                }
            }

            return {
                digAppsSelectionInput: digAppsWithActiveRules,
                availableDigAppsCount: Object.values(digAppsWithActiveRules).length
            };
        default:
            return state;
    }
}
